/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import * as React from "react";

import { ScheduleGroupPeopleCountRow } from "./ScheduleGroupPeopleCountRow";
import { getScheduleGroupCountRowProps } from "./ScheduleGroupPeopleCountRowContainer.mappers";
import { ScheduleGroupPeopleCountRowContainerProps } from "./ScheduleGroupPeopleCountRowContainerProps";

/**
 * Renders the row showing "Staff per 6 hours" for given schedule group id.
 * This is used in "Week" view only.
 * @param props The properties.
 * @returns The rendered "Staff per 6 hours" row.
 */
export const ScheduleGroupPeopleCountRowContainer: React.FC<ScheduleGroupPeopleCountRowContainerProps> = (props) => {
    const rowProps = getScheduleGroupCountRowProps(props);

    return (
        <ScheduleGroupPeopleCountRow {...rowProps} />
    );
};
